import { render, staticRenderFns } from "./imageAndText.vue?vue&type=template&id=86d50b3e"
import script from "./imageAndText.vue?vue&type=script&lang=js"
export * from "./imageAndText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports